import React, { useState } from "react";
import { AgCharts } from "ag-charts-react";
import { AgChartOptions } from "ag-charts-community";
import { useResponsive } from "../../hooks/useResponsive";

interface ResultsGraphProps {
  graphData: Record<string, number>;
  type: string;
}

const CATEGORY_COLORS: Record<string, string> = {
  'Dream Chaser': "#00A4EF",
  'Wealth Architect': "#00B3C2",
  'Safety Seeker': "#076652",
  'Generous Altruist': "#9933FF",
  'Freedom Finder': "#FF00FF",
};

const SPECIFIC_CATEGORY_COLORS: Record<string, string> = {
  'Visionary Investor': "#00CFEF",
  'Powerhouse Investor': "#0074EF",
  'Cautious Saver': "#77FF92",
  'Responsible Saver': "#00AE23",
  'Analytic Investor': "#7BCCD2",
  'Ambitious Builder': "#00757F",
  'Purpose-Driven Provider': "#BB77FF",
  'Empathetic Giver': "#6510B9",
  'Lifestyle Spender': "#FF8AFF",
  'Spontaneous Spender': "#D600D6",
};

export default function ResultsGraph({ graphData, type }: ResultsGraphProps) {
  const { isMobile } = useResponsive();
  // Prepare chart data, sorted descending
  const allData = Object.entries(graphData)
    .map(([category, value]) => ({ category, amount: value }))
    .sort((a, b) => b.amount - a.amount);

  // Show top 3 for main personality chart, all for specific
  const chartData = type === "main" ? allData.slice(0, 3) : allData;

  const fills = chartData.map(d =>
    type === "main"
      ? CATEGORY_COLORS[d.category]
      : SPECIFIC_CATEGORY_COLORS[d.category] || "#00A4EF"
  );

  // Calculate total for percentage
  const total = chartData.reduce((sum, d) => sum + d.amount, 0);

  const [options, setOptions] = useState<AgChartOptions>({
    data: chartData,
    legend: { enabled: false }, // Hide legend
    series: [
      {
        type: "donut",
        angleKey: "amount",
        fills,
        sectorSpacing: 3,
        outerRadiusOffset: -5,
        // calloutLabelKey: "category",
        // calloutLabel: {
        //   enabled: true,
        //   formatter: ({ datum }) => {
        //     const percent = Math.round((datum.amount / total) * 100);
        //     return `${datum.category} (${percent}%)`;
        //   },
        //   fontFamily: "Nunito",
        //   fontSize: isMobile ? 12 : 14,
        //   color: "#222",
        //   fontWeight: "bold",
        // },
        sectorLabel: {
          enabled: false,
        },
        tooltip: {
          enabled: true,
          renderer: ({ datum }) => `${datum.category}: ${datum.amount.toFixed(2)}`,
        },
      },
    ],
  });

  return (
      <AgCharts options={options}/>
  );
}